// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","customWhite":"#ffffff","customWhiteDk":"#fafafa","borderGrey":"#d5dfdf","caption":"_1dJD2pSCq2-UhXWE_3mRfd","errorRed":"#ff2a2a","customGreyLt":"#f2f2f2","container":"_1PnPt-HfVF--VxbjmR9XRE","error":"_1bGkHPgp6hbinycisoMnUV _1dJD2pSCq2-UhXWE_3mRfd","disabled":"VxH-9P9q2CStzGtWiGeuJ","arrow":"_2gYQcvewyrhIiQjnaAO5PD","value":"unFVJevlMv58llseDQ6BE","dropdown":"_1bKqHjqrZQ35ABAxJqoMiu","left":"_1-AMY5RVHrglAVmBysNbi7","right":"_3P2y-F4aJRwngUZRRm_o3J","element":"_2z39sEzl18B1pdDzN5Ot7y","selectedElement":"_1OnmGpvnXrOyCA0zr0vlSZ"};


//////////////////
// WEBPACK FOOTER
// ./src/common/select/Select.css
// module id = 366
// module chunks = 0 1 2